import * as PropTypes from 'prop-types';
import * as React from 'react';
import styles from './Navigation.module.scss.js';
import { ButtonAction } from '../ButtonAction/ButtonAction.js';
import { Icon } from '../Icon/Icon.js';

var Navigation = _ref => {
  var {
    labelText,
    previousDisabled,
    nextDisabled,
    previousOnClick,
    nextOnClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(ButtonAction, {
    className: "".concat(styles.button, " ").concat(styles.previous),
    disabled: previousDisabled,
    onClick: previousOnClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    screenreader: "Previous Slide",
    symbol: "controlChevronBack24",
    type: "svginline"
  })), labelText &&
  /*#__PURE__*/
  // eslint-disable-next-line
  React.createElement("label", {
    role: "status",
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Showing slide "), labelText), /*#__PURE__*/React.createElement(ButtonAction, {
    className: "".concat(styles.button, " ").concat(styles.next),
    disabled: nextDisabled,
    onClick: nextOnClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    screenreader: "Next Slide",
    symbol: "controlChevronForward24",
    type: "svginline"
  })));
};
Navigation.propTypes = {
  labelText: PropTypes.string,
  nextDisabled: PropTypes.bool,
  nextOnClick: PropTypes.func,
  previousDisabled: PropTypes.bool,
  previousOnClick: PropTypes.func
  // eslint-disable-next-line @typescript-eslint/no-explicit-any 
};

Navigation.displayName = 'Navigation';

export { Navigation };
